import { WhitelabelOnboardingState } from '../../../generated/internal.graphql';

/** Keyed off the generated enum, so a backend rename is a compile error, not a dead comparison. */
export const OnboardingState = Object.freeze({
  LIVE: WhitelabelOnboardingState.Live,
  HALF_BRANDED: WhitelabelOnboardingState.HalfBranded,
  NOT_SET_UP: WhitelabelOnboardingState.NotSetUp,
  COULD_NOT_CHECK: WhitelabelOnboardingState.CouldNotCheck,
  ORIGIN_GATE_UNCOVERED: WhitelabelOnboardingState.OriginGateUncovered,
});
export type OnboardingState = (typeof OnboardingState)[keyof typeof OnboardingState];
